"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transpiler = void 0;
var utils_1 = require("./utils");
var titleizer_1 = __importDefault(require("@json-schema-tools/titleizer"));
var referencer_1 = __importDefault(require("@json-schema-tools/referencer"));
var typescript_1 = __importDefault(require("./codegens/typescript"));
var rust_1 = __importDefault(require("./codegens/rust"));
var golang_1 = __importDefault(require("./codegens/golang"));
var python_1 = __importDefault(require("./codegens/python"));
/**
 * Provides a high-level interface for getting typings given a schema.
 */
var Transpiler = /** @class */ (function () {
    function Transpiler(s) {
        var useMerge = s instanceof Array;
        var inputSchema = useMerge ? s : [s];
        var cycleMap = utils_1.getCycleMap(inputSchema);
        var noTypeArrays = inputSchema.map(utils_1.replaceTypeAsArrayWithOneOf);
        var schemaWithTitles = noTypeArrays.map(titleizer_1.default);
        var reffed = schemaWithTitles.map(referencer_1.default);
        var reffedAndCycleMarked = reffed.map(function (s) { return utils_1.setIsCycle(s, cycleMap); });
        if (useMerge) {
            this.megaSchema = utils_1.combineSchemas(reffedAndCycleMarked);
        }
        else {
            this.megaSchema = reffedAndCycleMarked[0];
        }
    }
    /**
     * Generic transpile method.
     */
    Transpiler.prototype.to = function (lang) {
        return this["to" + utils_1.capitalize(lang)]();
    };
    /**
     * Returns the types in Typescript
     *
     * @returns The types present in the megaSchema, seperated by newlines.
     *
     * @category Typescript
     * @category TargetCodeGenerator
     *
     */
    Transpiler.prototype.toTypescript = function () {
        return this.transpile(new typescript_1.default(this.megaSchema));
    };
    /**
     * Alias to [[Transpiler.toTypescript]]
     *
     * @category Typescript
     * @category TargetCodeGenerator
     *
     */
    Transpiler.prototype.toTs = function () {
        return this.toTypescript();
    };
    /**
     * Returns the types in Rust
     *
     * @returns The types present in the megaSchema, seperated by newlines.
     *
     * @category Rust
     * @category TargetCodeGenerator
     *
     */
    Transpiler.prototype.toRust = function () {
        return this.transpile(new rust_1.default(this.megaSchema));
    };
    /**
     * Returns the types in Rust
     *
     * @returns The types present in the megaSchema, seperated by newlines.
     *
     * @category Rust
     * @category TargetCodeGenerator
     *
     */
    Transpiler.prototype.toRs = function () {
        return this.toRust();
    };
    /**
     * Returns the types in Rust
     *
     * @returns The types present in the megaSchema, seperated by newlines.
     *
     * @category Rust
     * @category TargetCodeGenerator
     *
     */
    Transpiler.prototype.toGolang = function () {
        return this.transpile(new golang_1.default(this.megaSchema));
    };
    /**
     * Returns the types in Rust
     *
     * @returns The types present in the megaSchema, seperated by newlines.
     *
     * @category Rust
     * @category TargetCodeGenerator
     *
     */
    Transpiler.prototype.toGo = function () {
        return this.toGolang();
    };
    /**
     * Returns the types in Python
     *
     * @returns The types present in the megaSchema, seperated by newlines.
     *
     * @category Python
     * @category TargetCodeGenerator
     *
     */
    Transpiler.prototype.toPython = function () {
        return this.transpile(new python_1.default(this.megaSchema));
    };
    /**
     * Returns the types in Python
     *
     * @returns The types present in the megaSchema, seperated by newlines.
     *
     * @category Python
     * @category TargetCodeGenerator
     *
     */
    Transpiler.prototype.toPy = function () {
        return this.toPython();
    };
    Transpiler.prototype.transpile = function (gen) {
        var codeLines = [];
        var prefix = gen.getCodePrefix();
        if (prefix) {
            codeLines.push(prefix);
            codeLines.push("");
        }
        codeLines.push(gen.transpile());
        return codeLines.join("\n");
    };
    return Transpiler;
}());
exports.Transpiler = Transpiler;
exports.default = Transpiler;
